@if (sorter) {
  <span
    class="no-select cursor-pointer text-nowrap"
    [ngClass]="sorter | sorterClasses: attr : direction : sorter.attr === attr : sorter.direction"
  >
    {{ label | transloco }}</span
  >
}
